import {
  GET_FORMS_REQUEST,
  GET_FORMS_SUCCESS,
  GET_FORMS_FAILURE,
  GET_FORM_DETAILS_REQUEST,
  GET_FORM_DETAILS_SUCCESS,
  GET_FORM_DETAILS_FAILURE,
  GET_FORM_DETAILS_CLEAR,
  GET_WHD_FORMS_REQUEST,
  GET_WHD_FORMS_SUCCESS,
  GET_WHD_FORMS_FAILURE,
  SEARCH_FORMS_REQUEST,
  SEARCH_FORMS_SUCCESS,
  SEARCH_FORMS_FAILURE,
  OPEN_ADD_FORM_MODAL,
  CLOSE_ADD_FORM_MODAL,
  OPEN_ADD_WHD_FORM_MODAL,
  CLOSE_ADD_WHD_FORM_MODAL,
  ADD_FORM_REQUEST,
  ADD_FORM_SUCCESS,
  ADD_FORM_FAILURE,
  RESET_ADDING_FORM,
  ADD_WHD_FORM_REQUEST,
  ADD_WHD_FORM_SUCCESS,
  ADD_WHD_FORM_FAILURE,
  RESET_ADDING_WHD_FORM,
  ADD_BENE_FORM_REQUEST,
  ADD_BENE_FORM_SUCCESS,
  ADD_BENE_FORM_FAILURE,
  RESET_BENE_ADDING_FORM,
  VALIDATE_FORM_REQUEST,
  VALIDATE_FORM_SUCCESS,
  VALIDATE_FORM_FAILURE,
  OPEN_DELETE_FORM_MODAL,
  CLOSE_DELETE_FORM_MODAL,
  DELETE_FORM_REQUEST,
  DELETE_FORM_SUCCESS,
  DELETE_FORM_FAILURE,
  DELETE_FORMS_REQUEST,
  DELETE_FORMS_SUCCESS,
  DELETE_FORMS_FAILURE,
  GET_FORM_BY_ID_REQUEST,
  GET_FORM_BY_ID_SUCCESS,
  GET_FORM_BY_ID_FAILURE,
  GET_FORM_PDF_REQUEST,
  GET_FORM_PDF_SUCCESS,
  GET_FORM_PDF_FAILURE,
  GET_FORM_PDF_RESET,
  GET_PDF_VIEW_REQUEST,
  GET_PDF_VIEW_SUCCESS,
  GET_PDF_VIEW_FAILURE,
  CHECK_FORM_PDF_EXISTENCE_REQUEST,
  CHECK_FORM_PDF_EXISTENCE_SUCCESS,
  CHECK_FORM_PDF_EXISTENCE_FAILURE,
  GET_VALIDATION_RESULTS_REQUEST,
  GET_VALIDATION_RESULTS_SUCCESS,
  GET_VALIDATION_RESULTS_FAILURE,
  SEARCH_VALIDATION_RESULTS_REQUEST,
  SEARCH_VALIDATION_RESULTS_SUCCESS,
  SEARCH_VALIDATION_RESULTS_FAILURE,
  EXPORT_TO_EXCEL_REQUEST,
  EXPORT_TO_EXCEL_SUCCESS,
  EXPORT_TO_EXCEL_FAILURE,
  OPEN_ADD_BENEFICIARY_FORM_MODAL,
  CLOSE_ADD_BENEFICIARY_FORM_MODAL,
  CHANGE_LAYER_BENEFICIARY_FORM_MODAL,
  CLOSE_PAYMENT_MODEL,
  OPEN_PAYMENT_MODEL,
  OPEN_DID_YOU_MEAN_MODAL,
  CLOSE_DID_YOU_MEAN_MODAL,
  UPDATE_FIELD_FROM_DID_YOU_MEAN,
  OPEN_PRIVACY_NOTICE_MODAL,
  CLOSE_PRIVACY_NOTICE_MODAL,
  TOGGLE_INSTRUCTION,
  SUPPORTING_DOC_ADDED,
  SUPPORTING_DOC_DELETE_REQUEST,
  SUPPORTING_DOC_DELETE_SUCCESS,
  SUPPORTING_DOC_DELETE_FAILURE,
  GET_SUPPORTING_DOC_REQUEST,
  GET_SUPPORTING_DOC_SUCCESS,
  GET_SUPPORTING_DOC_FAILURE,
  SAVE_FORM_REVIEW_STATE_REQUEST,
  SAVE_FORM_REVIEW_STATE_SUCCESS,
  SAVE_FORM_REVIEW_STATE_USER_ASSIGNMENT_SUCCESS,
  SAVE_FORM_REVIEW_STATE_FAILURE,
  SAVE_ACCOUNT_REVIEW_COMMENTS_REQUEST,
  SAVE_ACCOUNT_REVIEW_COMMENTS_SUCCESS,
  SAVE_ACCOUNT_REVIEW_COMMENTS_FAILURE,
  SAVE_DRAFT_OVERRIDES_REQUEST,
  SAVE_DRAFT_OVERRIDES_SUCCESS,
  SAVE_DRAFT_OVERRIDES_FAILURE,
  ACCEPT_OVERRIDES_REQUEST,
  ACCEPT_OVERRIDES_SUCCESS,
  ACCEPT_OVERRIDES_FAILURE,
  ACCEPT_FORM_OVERRIDE_REQUEST,
  ACCEPT_FORM_OVERRIDE_SUCCESS,
  ACCEPT_FORM_OVERRIDE_FAILURE,
  OPEN_FORM_OVERRIDE_MODAL,
  CLOSE_FORM_OVERRIDE_MODAL,
  OPEN_CANCEL_FORM_OVERRIDE_MODAL,
  CLOSE_CANCEL_FORM_OVERRIDE_MODAL,
  ACCOUNT_WITHHOLDING_OPEN_MODAL,
  ACCOUNT_WITHHOLDING_CLOSE_MODAL,
  ACCOUNT_WITHHOLDING_REQUEST,
  ACCOUNT_WITHHOLDING_SUCCESS,
  ACCOUNT_WITHHOLDING_FAILURE,
  IMYTREE_WITHHOLDING_FLAG,
  OPEN_EDIT_CUSTOMER_LEGAL_ENTITIES_MODAL,
  CLOSE_EDIT_CUSTOMER_LEGAL_ENTITIES_MODAL,
  CLOSE_EDIT_CUSTOMER_LEGAL_ENTITIES_ERROR,
  GET_CUSTOMER_LEGAL_ENTITIES_REQUEST,
  GET_CUSTOMER_LEGAL_ENTITIES_SUCCESS,
  GET_CUSTOMER_LEGAL_ENTITIES_ERROR,
  OPEN_EDIT_FORM_REFERENCE_MODAL,
  CLOSE_EDIT_FORM_REFERENCE_MODAL,
  CLOSE_EDIT_FORM_REFERENCE_ERROR,
  GET_FORM_REFERENCE_REQUEST,
  GET_FORM_REFERENCE_SUCCESS,
  GET_FORM_REFERENCE_ERROR,
  OPEN_ASSIGN_TO_USER_MODAL,
  CLOSE_ASSIGN_TO_USER_MODAL,
  CLOSE_ASSIGN_TO_USER_ERROR,
  EDIT_CUSTOMER_LEGAL_ENTITIES_SUCCESS,
  EDIT_CUSTOMER_LEGAL_ENTITIES_ERROR,
  EDIT_FORM_REFERENCE_REQUEST,
  EDIT_FORM_REFERENCE_SUCCESS,
  EDIT_FORM_REFERENCE_ERROR,
  ASSIGN_TO_USER_SUCCESS,
  ASSIGN_TO_USER_ERROR,
  OPEN_EDIT_FORM_ASSOCIATIONS_MODAL,
  CLOSE_EDIT_FORM_ASSOCIATIONS_MODAL,
  CLOSE_EDIT_FORM_ASSOCIATIONS_ERROR,
  EDIT_FORM_ASSOCIATIONS_REQUEST,
  EDIT_FORM_ASSOCIATIONS_SUCCESS,
  EDIT_FORM_ASSOCIATIONS_ERROR,
  OPEN_UNASSIGN_FORM_MODAL,
  CLOSE_UNASSIGN_FORM_MODAL,
  CLOSE_UNASSIGN_TO_USER_ERROR,
  UNASSIGN_TO_USER_SUCCESS,
  UNASSIGN_TO_USER_ERROR,
  PARENT_IMYFORMS_OPEN_MODAL,
  PARENT_IMYFORMS_CLOSE_MODAL,
  PARENT_IMYFORMS_REQUEST,
  PARENT_IMYFORMS_SUCCESS,
  PARENT_IMYFORMS_FAILURE,
  SAVE_IMY_TREEVIEW_OPTIONS,
  CLONE_FORM_REQUEST,
  CLONE_FORM_SUCCESS,
  CLONE_FORM_FAILURE,
  MOVE_FORM_REQUEST,
  MOVE_FORM_SUCCESS,
  MOVE_FORM_FAILURE,
  SET_PAYMENT_TYPES,
  UPDATE_AVAILABLE_PAYMENT_TYPES,
  SET_STRUCTURE_ID,
  POOLED_RATES_OPEN_MODAL,
  POOLED_RATES_CLOSE_MODAL,
  ADD_STATEMENT_REQUEST,
  ADD_STATEMENT_SUCCESS,
  ADD_STATEMENT_FAILURE,
  CREATE_WHD_REQUEST,
  CREATE_WHD_FAILURE,
  CREATE_WHD_SUCCESS,
  GET_WHD_FORMS_ACCOUNT_SUCCESS,
  GET_WHD_FORMS_ACCOUNT_REQUEST,
  GET_WHD_FORMS_ACCOUNT_FAILURE,
  GET_WHD_VERSIONS_REQUEST,
  GET_WHD_VERSIONS_SUCCESS,
  GET_WHD_VERSIONS_FAILURE,
  OPEN_SPECIAL_RATE_ADDITION_MODAL,
  CLOSE_SPECIAL_RATE_ADDITION_MODAL,
  OPEN_PUBLISHED_DATE_UPDATE_MODAL,
  CLOSE_PUBLISHED_DATE_UPDATE_MODAL,
  UPDATE_VERSION_STMT_SUCCESS,
  CHECK_TIN_REQUEST,
  CHECK_TIN_SUCCESS,
  CHECK_TIN_FAILURE,
  OPEN_EDIT_ADDRESS_MODAL,
  CLOSE_EDIT_ADDRESS_MODAL,
  UPDATE_GRID_TOTAL_LIMIT,
  DOWNLOAD_FORM_SUMMARY_REQUEST,
  DOWNLOAD_FORM_SUMMARY_SUCCESS,
  DOWNLOAD_FORM_SUMMARY_FAILURE,
  GET_FORM_SUMMARY_PDF_CLEAR
} from 'actions';

// eslint-disable-next-line default-param-last
function forms(state = {
  isGettingForms: false,
  isGettingWhdForms: false,
  isAddFormModalShown: false,
  isAddWhdCalcModalShown: false,
  isAddingForm: false,
  addingFormResults: null,
  isAddingWhdForm: false,
  forms: [],
  formsCount: 0,
  gridTotalLimit: 0,
  additionalRowDict: null,
  getFormDetailsError: null,
  whdForms: [],
  isValidatingForm: false,
  isGettingFormById: false,
  formByIdResponse: null,
  formByIdError: null,
  supportingDocs: [],
  isCheckingFormPdfExistence: false,
  formPdfExists: false,
  isGettingReporting: false,
  reportingResponse: { results: [], totalCount: 0 },
  isExportingToExcel: false,
  isDownloadingFormSummary: false,
  isAddBeneficiarFormModalShown: false,
  isAddingImyToExistingLayer: false,
  imyTier: null,
  addImyLayer: null,
  isPaymentModalShown: false,
  isDidYouMeanModalShown: false,
  isPrivacyNoticeModalShown: false,
  instructionToggled: null,
  filteredValues: [],
  paymentValues: {},
  isDeletingSupportingDocId: null,
  supportingDocError: null,
  isFetchingSupportingDoc: false,
  supportingDocData: null,
  supportingDocFilename: null,
  supportingDocContentType: 'application/octet-stream',
  getSupportingDocError: null,
  isSavingFormReviewState: false,
  formReviewState: null,
  workflowState: null,
  formReviewStateError: null,
  isSavingOverrides: false,
  validationOverridesError: null,
  isFormOverrideModalShown: false,
  isCancelFormOverrideModalShown: false,
  isAccountWithholdingShown: false,
  accountWithholding: null,
  showRate: false,
  currentForm: null,
  isAssignToUserModalShown: false,
  isEditCustomerLegalEntitiesModalShown: false,
  deleteFormError: null,
  newFormReference: null,
  formsList: [],
  isUnassignModalShown: false,
  currentStructureId: 0,
  imyTreeViewOptions: [{
    structureId: 0,
    displayMode: 'all',
    showWithholdingRates: false,
    selectedPaymentTypes: [],
    availablePaymentTypes: []
  }],
  isParentImyFormsShown: false,
  isGettingParentImyForms: false,
  isMovingForm: false,
  moveFormComplete: false,
  isCloningForm: false,
  cloneFormComplete: false,
  addStatementResults: null,
  isAddingStatement: false,
  isCreatingNewWhd: false,
  accountWithholdingStatement: null,
  isGettingWhdForAccount: false,
  isPooledRatesModalShown: false,
  statementVersions: null,
  isLoadingStatementVersions: false,
  isSpecialRatesModalShown: false,
  specialRatesModalError: null,
  isEditAddressModalShown: false,
  addressProps: null,
  pdfFile: null,
  pdfDownloads: [],
  isShowingPublishedVersionsUpdate: false,
  publishedVersionIndex: -1,
  refreshVersions: false,
  ignoreDirtyTaxForm: false,
  isCheckingTin: false
}, action) {
  switch (action.type) {
    case IMYTREE_WITHHOLDING_FLAG:
      return {
        ...state,
        showRate: action.showRate
      };
    case GET_FORMS_REQUEST:
      return {
        ...state,
        isGettingForms: action.isGettingForms
      };
    case GET_FORMS_SUCCESS:
      return {
        ...state,
        isGettingForms: action.isGettingForms,
        forms: action.forms,
        formsCount: action.formsCount,
        gridTotalLimit: action.gridTotalLimit,
      };
    case GET_FORMS_FAILURE:
      return {
        ...state,
        isGettingForms: action.isGettingForms,
        getFormsError: action.getFormsError,
        forms: [],
        formsCount: 0,
        gridTotalLimit: 0
      };
    case GET_FORM_DETAILS_REQUEST:
      // eslint-disable-next-line no-case-declarations
      const requestForms = state.forms.filter((f, i) => f.id === action.formId && i === action.rowId);

      if (requestForms && requestForms.length === 1) {
        requestForms[0].isLoadingDetails = true;
      }

      return {
        ...state,
        getFormDetailsError: null,
        forms: state.forms.concat([])
      };
    case GET_FORM_DETAILS_SUCCESS:
      // eslint-disable-next-line no-case-declarations
      const matchedForms = state.forms.filter((f, i) => f.id === action.formId && i === action.rowId);

      if (matchedForms && matchedForms.length === 1) {
        matchedForms[0].additionalData = action.formDetails;
        matchedForms[0].isLoadingDetails = false;
      }

      return {
        ...state,
        getFormDetailsError: null,
        forms: state.forms.concat([])
      };
    case GET_FORM_DETAILS_CLEAR:
      // eslint-disable-next-line no-case-declarations
      const clearForms = state.forms.filter((f, i) => f.id === action.formId && i === action.rowId);

      if (clearForms && clearForms.length === 1) {
        clearForms[0].additionalData = null;
        clearForms[0].isLoadingDetails = false;
      }

      return {
        ...state,
        getFormDetailsError: null,
        forms: state.forms.concat([])
      };
    case GET_FORM_DETAILS_FAILURE:
      // eslint-disable-next-line no-case-declarations
      const failureForms = state.forms.filter((f, i) => f.id === action.formId && i === action.rowId);

      if (failureForms && failureForms.length === 1) {
        failureForms[0].additionalData = null;
        failureForms[0].isLoadingDetails = false;
      }

      return {
        ...state,
        getFormDetailsError: action.getFormDetailsError,
        forms: state.forms.concat([])
      };
    case UPDATE_GRID_TOTAL_LIMIT:
      return {
        ...state,
        gridTotalLimit: action.gridTotalLimit
      };
    case GET_WHD_FORMS_REQUEST:
      return {
        ...state,
        isGettingWhdForms: action.isGettingWhdForms
      };
    case GET_WHD_FORMS_SUCCESS:
      return {
        ...state,
        isGettingWhdForms: action.isGettingWhdForms,
        whdForms: action.whdForms
      };
    case SEARCH_FORMS_REQUEST:
      return {
        ...state,
        isGettingForms: action.isGettingForms
      };
    case SEARCH_FORMS_SUCCESS:
      return {
        ...state,
        isGettingForms: action.isGettingForms,
        forms: action.forms,
        formsCount: action.formsCount,
        gridTotalLimit: action.gridTotalLimit,
      };
    case SEARCH_FORMS_FAILURE:
      return {
        ...state,
        isGettingForms: action.isGettingForms,
        getFormsError: action.getFormsError
      };
    case GET_WHD_FORMS_FAILURE:
      return {
        ...state,
        isGettingWhdForms: action.isGettingWhdForms,
        getFormsError: action.getFormsError
      };
    case OPEN_ADD_FORM_MODAL:
      return {
        ...state,
        isAddFormModalShown: action.isAddFormModalShown,
        imyTier: action.imyTier,
        addImyLayer: action.addImyLayer
      };
    case CLOSE_ADD_FORM_MODAL:
      return {
        ...state,
        isAddFormModalShown: action.isAddFormModalShown,
        imyTier: action.imyTier,
        addImyLayer: action.addImyLayer,
        isAddingForm: action.isAddingForm,
        addingFormResults: action.addingFormResults
      };
    case OPEN_ADD_WHD_FORM_MODAL:
      return {
        ...state,
        isAddWhdCalcModalShown: action.isAddWhdCalcModalShown
      };
    case CLOSE_ADD_WHD_FORM_MODAL:
      return {
        ...state,
        isAddWhdCalcModalShown: action.isAddWhdCalcModalShown,
        isAddingWhdForm: action.isAddingWhdForm,
        addingWhdFormError: action.addingWhdFormError
      };
    case ADD_FORM_REQUEST:
      return {
        ...state,
        isAddingForm: action.isAddingForm
      };
    case ADD_FORM_SUCCESS:
      return {
        ...state,
        isAddingForm: action.isAddingForm,
        addingFormResults: action.addingFormResults
      };
    case ADD_FORM_FAILURE:
      return {
        ...state,
        isAddingForm: action.isAddingForm,
        addingFormResults: action.addingFormResults
      };
    case RESET_ADDING_FORM:
      return {
        ...state,
        addingFormResults: action.addingFormResults
      };
    case ADD_WHD_FORM_REQUEST:
      return {
        ...state,
        isAddingWhdForm: action.isAddingWhdForm
      };
    case ADD_WHD_FORM_SUCCESS:
      return {
        ...state,
        isAddingWhdForm: action.isAddingWhdForm,
        addingWhdFormResponse: action.addingWhdFormResponse
      };
    case ADD_WHD_FORM_FAILURE:
      return {
        ...state,
        isAddingWhdForm: action.isAddingWhdForm,
        addingWhdFormError: action.addingWhdFormError
      };
    case RESET_ADDING_WHD_FORM:
      return {
        ...state,
        addingWhdFormError: action.addingWhdFormError
      };
    case ADD_BENE_FORM_REQUEST:
      return {
        ...state,
        isAddingBeneForm: action.isAddingBeneForm
      };
    case ADD_BENE_FORM_SUCCESS:
      return {
        ...state,
        isAddingBeneForm: action.isAddingBeneForm,
        addingBeneFormResponse: action.addingBeneFormResponse
      };
    case ADD_BENE_FORM_FAILURE:
      return {
        ...state,
        isAddingBeneForm: action.isAddingBeneForm,
        addingBeneFormError: action.addingBeneFormError
      };
    case RESET_BENE_ADDING_FORM:
      return {
        ...state,
        addingBeneFormError: action.addingBeneFormError
      };
    case VALIDATE_FORM_REQUEST:
      return {
        ...state,
        isValidatingForm: action.isValidatingForm,
        formId: action.formId
      };
    case VALIDATE_FORM_SUCCESS: {
      const newFormByIdResponse = state.formByIdResponse;
      let currentResults = state.formByIdResponse?.tinMatchResult ?? [];
      const indexOfTinMatchResult = currentResults?.findIndex(result => result.formId === action.validationResult.tinMatchResult[0]?.formId);

      if (currentResults && action.validationResult.tinMatchResult?.length > 0) {
        if (indexOfTinMatchResult >= 0) {
          currentResults.splice(indexOfTinMatchResult, 1, action.validationResult.tinMatchResult[0]);
        } else if (indexOfTinMatchResult === -1) {
          currentResults.push(action.validationResult.tinMatchResult[0]);
        } else {
          currentResults = action.validationResult.tinMatchResult;
        }

        newFormByIdResponse.tinMatchResult = currentResults;
      }

      return {
        ...state,
        formByIdResponse: newFormByIdResponse,
        isValidatingForm: action.isValidatingForm,
        validationResult: action.validationResult,
        validationFormError: action.validationFormError
      };
    }
    case VALIDATE_FORM_FAILURE:
      return {
        ...state,
        isValidatingForm: action.isValidatingForm,
        validationFormError: action.validationFormError
      };
    case OPEN_DELETE_FORM_MODAL:
      return {
        ...state,
        isDeleteFormModalShown: action.isDeleteFormModalShown,
        formsToDelete: action.formsToDelete,
        deleteFormResponse: null,
        deleteFormError: null
      };
    case CLOSE_DELETE_FORM_MODAL:
      return {
        ...state,
        isDeleteFormModalShown: action.isDeleteFormModalShown,
      };
    case DELETE_FORM_REQUEST:
      return {
        ...state,
        isDeletingForm: action.isDeletingForm
      };
    case DELETE_FORM_SUCCESS:
      return {
        ...state,
        isDeletingForm: action.isDeletingForm,
        deleteFormResponse: action.deleteFormResponse,
        deleteFormError: action.deleteFormError
      };
    case DELETE_FORM_FAILURE:
      return {
        ...state,
        isDeletingForm: action.isDeletingForm,
        deleteFormError: action.deleteFormError
      };
    case DELETE_FORMS_REQUEST:
      return {
        ...state,
        isDeletingForms: action.isDeletingForms,
        deleteFormsResponse: action.deleteFormsResponse
      };
    case DELETE_FORMS_SUCCESS:
      return {
        ...state,
        isDeletingForms: action.isDeletingForms,
        deleteFormsResponse: action.deleteFormsResponse,
        deleteFormsError: action.deleteFormsError
      };
    case DELETE_FORMS_FAILURE:
      return {
        ...state,
        isDeletingForms: action.isDeletingForms,
        deleteFormsResponse: action.deleteFormsResponse,
        deleteFormsError: action.deleteFormsError
      };
    case GET_FORM_BY_ID_REQUEST:
      return {
        ...state,
        isGettingFormById: action.isGettingFormById,
        formByIdResponse: action.formByIdResponse,
        validationResult: action.validationResult,
        supportingDocs: action.supportingDocs,
        formReviewState: action.formReviewState,
        workflowState: action.workflowState,
        viewPdfData: action.viewPdfData,
        formByIdError: action.formByIdError,
        accountWithholdingStatement: null
      };
    case GET_FORM_BY_ID_SUCCESS:
      return {
        ...state,
        isGettingFormById: action.isGettingFormById,
        formByIdResponse: action.formByIdResponse,
        validationResult: action.validationResult,
        supportingDocs: action.supportingDocs,
        formReviewState: action.formReviewState,
        workflowState: action.workflowState,
        formByIdError: action.formByIdError,
        ignoreDirtyTaxForm: false
      };
    case GET_FORM_BY_ID_FAILURE:
      return {
        ...state,
        isGettingFormById: action.isGettingFormById,
        formByIdError: action.formByIdError,
        ignoreDirtyTaxForm: false
      };
    case GET_FORM_PDF_REQUEST:
      return {
        ...state,
        isFetchingPdfForm: action.isFetchingPdfForm,
        pdfFile: null
      };
    case GET_FORM_PDF_SUCCESS:
      // eslint-disable-next-line no-case-declarations
      const matchingDownloads = state.pdfDownloads.filter(x => x.id === action.pdfFile.id);
      if (matchingDownloads?.length === 0 && action.pdfFile) {
        state.pdfDownloads.push(action.pdfFile);
      }

      return {
        ...state,
        isFetchingPdfForm: action.isFetchingPdfForm,
        pdfFile: action.pdfFile,
        getFormPdfError: action.getFormPdfError
      };
    case GET_FORM_PDF_FAILURE:
      return {
        ...state,
        isFetchingPdfForm: action.isFetchingPdfForm,
        pdfFile: null,
        getFormPdfError: action.getFormPdfError
      };
    case GET_FORM_PDF_RESET:
      for (let f = 0; f < state.pdfDownloads.length; f += 1) {
        URL.revokeObjectURL(state.pdfDownloads[f].blob);
      }

      return {
        ...state,
        pdfFile: null,
        pdfDownloads: []
      };
    case GET_PDF_VIEW_REQUEST:
      return {
        ...state,
        isFetchingPdfView: action.isFetchingPdfView
      };
    case GET_PDF_VIEW_SUCCESS:
      // eslint-disable-next-line no-case-declarations
      const matchingViewDownloads = state.pdfDownloads.filter(x => x.id === action.pdfFile.id);
      if (matchingViewDownloads?.length === 0 && action.pdfFile) {
        state.pdfDownloads.push(action.pdfFile);
      }

      return {
        ...state,
        isFetchingPdfView: action.isFetchingPdfView,
        viewPdfData: action.pdfFile.blob,
        getPdfViewError: action.getPdfViewError
      };
    case GET_PDF_VIEW_FAILURE:
      return {
        ...state,
        isFetchingPdfView: action.isFetchingPdfView,
        getPdfViewError: action.getPdfViewError
      };
    case CHECK_FORM_PDF_EXISTENCE_REQUEST:
      return {
        ...state,
        isCheckingFormPdfExistence: action.isCheckingFormPdfExistence,
        formPdfExists: action.formPdfExists
      };
    case CHECK_FORM_PDF_EXISTENCE_SUCCESS:
      return {
        ...state,
        isCheckingFormPdfExistence: action.isCheckingFormPdfExistence,
        formPdfExists: action.formPdfExists
      };
    case CHECK_FORM_PDF_EXISTENCE_FAILURE:
      return {
        ...state,
        isCheckingFormPdfExistence: action.isCheckingFormPdfExistence,
        formPdfExists: action.formPdfExists,
        formPdfExistenceError: action.formPdfExistenceError
      };
    case GET_VALIDATION_RESULTS_REQUEST:
      return {
        ...state,
        isGettingReporting: action.isGettingReporting
      };
    case GET_VALIDATION_RESULTS_SUCCESS:
      return {
        ...state,
        isGettingReporting: action.isGettingReporting,
        reportingResponse: action.reportingResponse,
        reportingError: action.reportingError
      };
    case GET_VALIDATION_RESULTS_FAILURE:
      return {
        ...state,
        isGettingReporting: action.isGettingReporting,
        reportingError: action.reportingError
      };
    case SEARCH_VALIDATION_RESULTS_REQUEST:
      return {
        ...state,
        isGettingReporting: action.isGettingReporting
      };
    case SEARCH_VALIDATION_RESULTS_SUCCESS:
      return {
        ...state,
        isGettingReporting: action.isGettingReporting,
        reportingResponse: action.reportingResponse,
        reportingError: action.reportingError
      };
    case SEARCH_VALIDATION_RESULTS_FAILURE:
      return {
        ...state,
        isGettingReporting: action.isGettingReporting,
        reportingError: action.reportingError
      };
    case EXPORT_TO_EXCEL_REQUEST:
      return {
        ...state,
        isExportingToExcel: action.isExportingToExcel
      };
    case EXPORT_TO_EXCEL_SUCCESS:
      return {
        ...state,
        isExportingToExcel: action.isExportingToExcel,
        excelData: action.excelData,
        exportToExcelError: action.exportToExcelError
      };
    case EXPORT_TO_EXCEL_FAILURE:
      return {
        ...state,
        isExportingToExcel: action.isExportingToExcel,
        exportToExcelError: action.exportToExcelError
      };
    case DOWNLOAD_FORM_SUMMARY_REQUEST:
      return {
        ...state,
        isDownloadingFormSummary: action.isDownloadingFormSummary
      };
    case DOWNLOAD_FORM_SUMMARY_SUCCESS:
      return {
        ...state,
        isDownloadingFormSummary: action.isDownloadingFormSummary,
        formSummaryData: action.formSummaryData,
        dowloadFormSummaryError: action.dowloadFormSummaryError
      };
    case DOWNLOAD_FORM_SUMMARY_FAILURE:
      return {
        ...state,
        isDownloadingFormSummary: action.isDownloadingFormSummary,
        dowloadFormSummaryError: action.dowloadFormSummaryError
      };
    case GET_FORM_SUMMARY_PDF_CLEAR:
      if (state.formSummaryData) {
        URL.revokeObjectURL(state.formSummaryData);
      }
      return {
        ...state,
        formSummaryData: null
      };
    case OPEN_ADD_BENEFICIARY_FORM_MODAL:
      return {
        ...state,
        isAddBeneficiarFormModalShown: action.isAddBeneficiarFormModalShown,
        isAddingImyToExistingLayer: action.isAddingImyToExistingLayer,
        parentW8ImyForm: action.parentW8ImyForm
      };
    case CLOSE_ADD_BENEFICIARY_FORM_MODAL:
      return {
        ...state,
        isAddBeneficiarFormModalShown: action.isAddBeneficiarFormModalShown,
        isAddingImyToExistingLayer: action.isAddingImyToExistingLayer
      };
    case CHANGE_LAYER_BENEFICIARY_FORM_MODAL:
      return {
        ...state,
        isAddingImyToExistingLayer: action.isAddingImyToExistingLayer
      };
    case CLOSE_PAYMENT_MODEL:
      return {
        ...state,
        isPaymentModalShown: action.isPaymentModalShown
      };
    case OPEN_PAYMENT_MODEL:
      return {
        ...state,
        isPaymentModalShown: action.isPaymentModalShown,
        paymentValues: action.paymentValues
      };
    case OPEN_DID_YOU_MEAN_MODAL:
      return {
        ...state,
        isDidYouMeanModalShown: action.isDidYouMeanModalShown,
        filteredValues: action.filteredValues,
        renderedfieldName: action.renderedfieldName,
        modalId: action.modalId
      };
    case CLOSE_DID_YOU_MEAN_MODAL:
      return {
        ...state,
        isDidYouMeanModalShown: action.isDidYouMeanModalShown,
        renderedfieldName: action.renderedfieldName,
        modalId: action.modalId
      };
    case UPDATE_FIELD_FROM_DID_YOU_MEAN:
      return {
        ...state,
        isDidYouMeanModalShown: action.isDidYouMeanModalShown,
        renderedfieldName: action.renderedfieldName,
        modalId: action.modalId
      };
    case OPEN_PRIVACY_NOTICE_MODAL:
      return {
        ...state,
        isPrivacyNoticeModalShown: action.isPrivacyNoticeModalShown
      };
    case CLOSE_PRIVACY_NOTICE_MODAL:
      return {
        ...state,
        isPrivacyNoticeModalShown: action.isPrivacyNoticeModalShown
      };
    case TOGGLE_INSTRUCTION:
      return {
        ...state,
        instructionToggled: action.instructionToggled
      };
    case SUPPORTING_DOC_ADDED:
      return {
        ...state,
        supportingDocs: action.newSupportingDoc ? state.supportingDocs.concat(action.newSupportingDoc) : state.supportingDocs
      };
    case SUPPORTING_DOC_DELETE_REQUEST:
      return {
        ...state,
        isDeletingSupportingDocId: action.isDeletingSupportingDocId,
      };
    case SUPPORTING_DOC_DELETE_SUCCESS:
      return {
        ...state,
        isDeletingSupportingDocId: null,
        supportingDocs: state.supportingDocs ? state.supportingDocs.filter(doc => doc.id !== action.isDeletingSupportingDocId) : state.supportingDocs
      };
    case SUPPORTING_DOC_DELETE_FAILURE:
      return {
        ...state,
        isDeletingSupportingDocId: action.isDeletingSupportingDocId,
        supportingDocError: action.supportingDocError
      };
    case GET_SUPPORTING_DOC_REQUEST:
      return {
        ...state,
        isFetchingSupportingDoc: action.isFetchingSupportingDoc
      };
    case GET_SUPPORTING_DOC_SUCCESS:
      return {
        ...state,
        isFetchingSupportingDoc: action.isFetchingSupportingDoc,
        supportingDocData: action.supportingDocData,
        supportingDocFilename: action.supportingDocFilename,
        supportingDocContentType: action.supportingDocContentType,
        getSupportingDocError: action.getSupportingDocError
      };
    case GET_SUPPORTING_DOC_FAILURE:
      return {
        ...state,
        isFetchingSupportingDoc: action.isFetchingSupportingDoc,
        getSupportingDocError: action.getSupportingDocError
      };
    case SAVE_FORM_REVIEW_STATE_REQUEST:
      return {
        ...state,
        isSavingFormReviewState: action.isSavingFormReviewState,
        ignoreDirtyTaxForm: true
      };
    case SAVE_FORM_REVIEW_STATE_SUCCESS:
      return {
        ...state,
        isSavingFormReviewState: action.isSavingFormReviewState,
        formReviewState: action.formReviewState,
        formReviewStateError: action.formReviewStateError
      };
    case SAVE_FORM_REVIEW_STATE_USER_ASSIGNMENT_SUCCESS:
      return {
        ...state,
        isSavingFormReviewState: action.isSavingFormReviewState,
        formReviewState: action.formReviewState,
        formReviewStateError: action.formReviewStateError
      };
    case SAVE_FORM_REVIEW_STATE_FAILURE:
      return {
        ...state,
        isSavingFormReviewState: action.isSavingFormReviewState,
        formReviewStateError: action.formReviewStateError
      };
    case SAVE_ACCOUNT_REVIEW_COMMENTS_REQUEST:
      return {
        ...state,
        isSavingFormReviewState: action.isSavingFormReviewState
      };
    case SAVE_ACCOUNT_REVIEW_COMMENTS_SUCCESS:
      if (state.formReviewState && action.accountReview) {
        let newReviewComments = state.formReviewState.accountComments ? Object.assign(state.formReviewState.accountComments, {}) : [];
        const matchedAccount = newReviewComments.filter(a => a.accountId === action.accountReview.accountId);
        if (matchedAccount && matchedAccount.length > 0) {
          matchedAccount[0].draftComments = action.accountReview.draftComments;
          newReviewComments = newReviewComments.map(a => (a.accountId === matchedAccount[0].accountId ? matchedAccount[0] : a));
          state.formReviewState.accountComments = newReviewComments;
        } else if (state.formReviewState.accountComments) {
          state.formReviewState.accountComments.push({ accountId: action.accountReview.accountId, draftComments: action.accountReview.draftComments });
        } else {
          state.formReviewState.accountComments = [{ accountId: action.accountReview.accountId, draftComments: action.accountReview.draftComments }];
        }
      }

      return {
        ...state,
        isSavingFormReviewState: action.isSavingFormReviewState,
        formReviewState: Object.assign(state.formReviewState, {}),
        formReviewStateError: action.formReviewStateError
      };
    case SAVE_ACCOUNT_REVIEW_COMMENTS_FAILURE:
      return {
        ...state,
        isSavingFormReviewState: action.isSavingFormReviewState,
        formReviewStateError: action.formReviewStateError
      };
    case SAVE_DRAFT_OVERRIDES_REQUEST:
      return {
        ...state,
        isSavingOverrides: action.isSavingOverrides,
      };
    case SAVE_DRAFT_OVERRIDES_SUCCESS:
      return {
        ...state,
        isSavingOverrides: action.isSavingOverrides,
        validationResult: {
          ...state.validationResult,
          result: [
            ...(state.validationResult.result.map(item => (item.accountId === action.accountId && item.formId === action.formId
              ? { ...item, overrides: { ...item.overrides, draft: action.draftOverrides } }
              : item)))
          ]
        },
        validationOverridesError: action.validationOverridesError
      };
    case SAVE_DRAFT_OVERRIDES_FAILURE:
      return {
        ...state,
        isSavingOverrides: action.isSavingOverrides,
        validationOverridesError: action.validationOverridesError
      };
    case ACCEPT_OVERRIDES_REQUEST:
    case ACCEPT_FORM_OVERRIDE_REQUEST:
      return {
        ...state,
        isSavingOverrides: action.isSavingOverrides,
        isFormOverrideModalShown: false
      };
    case ACCEPT_OVERRIDES_SUCCESS:
    case ACCEPT_FORM_OVERRIDE_SUCCESS:
      return {
        ...state,
        isSavingOverrides: action.isSavingOverrides,
        isFormOverrideModalShown: false,
        validationResult: action.validationResult,
        validationOverridesError: action.validationOverridesError
      };
    case ACCEPT_OVERRIDES_FAILURE:
    case ACCEPT_FORM_OVERRIDE_FAILURE:
      return {
        ...state,
        isSavingOverrides: action.isSavingOverrides,
        validationOverridesError: action.validationOverridesError
      };
    case OPEN_FORM_OVERRIDE_MODAL:
      return {
        ...state,
        isFormOverrideModalShown: true,
      };
    case CLOSE_FORM_OVERRIDE_MODAL:
      return {
        ...state,
        isFormOverrideModalShown: false,
      };
    case OPEN_CANCEL_FORM_OVERRIDE_MODAL:
      return {
        ...state,
        isCancelFormOverrideModalShown: true,
      };
    case CLOSE_CANCEL_FORM_OVERRIDE_MODAL:
      return {
        ...state,
        isCancelFormOverrideModalShown: false,
      };
    case ACCOUNT_WITHHOLDING_OPEN_MODAL:
      return {
        ...state,
        isAccountWithholdingShown: true
      };
    case ACCOUNT_WITHHOLDING_CLOSE_MODAL:
      return {
        ...state,
        isAccountWithholdingShown: false,
        accountWithholding: null
      };
    case ACCOUNT_WITHHOLDING_REQUEST:
      return {
        ...state,
        isGettingAccountWithholding: true,
        accountWithholding: null
      };
    case ACCOUNT_WITHHOLDING_SUCCESS:
      return {
        ...state,
        isGettingAccountWithholding: false,
        accountWithholding: action.accountWithholding
      };
    case ACCOUNT_WITHHOLDING_FAILURE:
      return {
        ...state,
        isAccountWithholdingShown: false,
        isGettingAccountWithholding: false,
        accountWithholding: null
      };
    case OPEN_EDIT_CUSTOMER_LEGAL_ENTITIES_MODAL:
      return {
        ...state,
        isEditCustomerLegalEntitiesModalShown: action.isEditCustomerLegalEntitiesModalShown,
        currentForm: action.currentForm,
        isTaskSuccess: false
      };
    case CLOSE_EDIT_CUSTOMER_LEGAL_ENTITIES_MODAL:
      return {
        ...state,
        isEditCustomerLegalEntitiesModalShown: action.isEditCustomerLegalEntitiesModalShown,
        editCustomerLegalEntitiesResponse: action.editCustomerLegalEntitiesResponse,
        editCustomerLegalEntitiesError: action.editCustomerLegalEntitiesError,
        legalEntityList: null,
        isTaskSuccess: false
      };
    case CLOSE_EDIT_CUSTOMER_LEGAL_ENTITIES_ERROR:
      return {
        ...state,
        isEditCustomerLegalEntitiesModalShown: action.isEditCustomerLegalEntitiesModalShown,
        isTaskSuccess: false
      };
    case GET_CUSTOMER_LEGAL_ENTITIES_REQUEST:
      return {
        ...state,
        isGettingCustomerLegalEntities: true,
        legalEntityList: null,
        isTaskSuccess: false
      };
    case GET_CUSTOMER_LEGAL_ENTITIES_SUCCESS:
      return {
        ...state,
        isGettingCustomerLegalEntities: false,
        legalEntityList: action.legalEntityList,
        isTaskSuccess: false
      };
    case GET_CUSTOMER_LEGAL_ENTITIES_ERROR:
      return {
        ...state,
        isGettingCustomerLegalEntities: false,
        legalEntityList: null,
      };
    case EDIT_CUSTOMER_LEGAL_ENTITIES_SUCCESS:
      return {
        ...state,
        isTaskSuccess: true
      };
    case EDIT_CUSTOMER_LEGAL_ENTITIES_ERROR:
      return {
        ...state,
        isTaskSuccess: false
      };
    case OPEN_EDIT_FORM_REFERENCE_MODAL:
      return {
        ...state,
        isEditFormReferenceModalShown: action.isEditFormReferenceModalShown,
        currentForm: action.currentForm,
        isTaskSuccess: false
      };
    case CLOSE_EDIT_FORM_REFERENCE_MODAL:
      return {
        ...state,
        isEditFormReferenceModalShown: action.isEditFormReferenceModalShown,
        editFormReferenceResponse: action.editFormReferenceResponse,
        editFormReferenceError: action.editFormReferenceError,
        isTaskSuccess: false
      };
    case CLOSE_EDIT_FORM_REFERENCE_ERROR:
      return {
        ...state,
        isEditFormReferenceModalShown: action.isEditFormReferenceModalShown,
        isTaskSuccess: false
      };
    case GET_FORM_REFERENCE_REQUEST:
      return {
        ...state,
        isGettingFormReference: true,
        isTaskSuccess: false
      };
    case GET_FORM_REFERENCE_SUCCESS:
      return {
        ...state,
        isGettingFormReference: false,
        formData: action.formData,
        isTaskSuccess: false
      };
    case GET_FORM_REFERENCE_ERROR:
      return {
        ...state,
        isGettingFormReference: false,
      };
    case EDIT_FORM_REFERENCE_REQUEST:
      return {
        ...state,
        newFormReference: action.newFormReference
      };
    case EDIT_FORM_REFERENCE_SUCCESS:
      if (state.currentForm && state.currentForm.length === 1 && state.currentForm[0].id) {
        const refForms = state.forms.filter(f => f.id === state.currentForm[0].id);

        if (refForms && refForms.length === 1 && refForms[0].additionalData) {
          refForms[0].additionalData.reference = state.newFormReference;
          refForms[0].isLoadingDetails = false;
        }

        return {
          ...state,
          getFormDetailsError: null,
          newFormReference: null,
          forms: state.forms.concat([]),
          isTaskSuccess: true
        };
      }
      return { ...state };
    case EDIT_FORM_REFERENCE_ERROR:
      return {
        ...state,
        newFormReference: null,
        isTaskSuccess: false
      };
    case OPEN_ASSIGN_TO_USER_MODAL:
      return {
        ...state,
        isAssignToUserModalShown: action.isAssignToUserModalShown,
        formsList: action.formsList,
        isTaskSuccess: false
      };
    case CLOSE_ASSIGN_TO_USER_MODAL:
      return {
        ...state,
        isAssignToUserModalShown: action.isAssignToUserModalShown,
        isTaskSuccess: false
      };
    case CLOSE_ASSIGN_TO_USER_ERROR:
      return {
        ...state,
        isAssignToUserModalShown: action.isAssignToUserModalShown,
        isTaskSuccess: false
      };
    case ASSIGN_TO_USER_SUCCESS:
      return {
        ...state,
        isTaskSuccess: true
      };
    case ASSIGN_TO_USER_ERROR:
      return {
        ...state,
        isTaskSuccess: false
      };
    case OPEN_EDIT_FORM_ASSOCIATIONS_MODAL:
      return {
        ...state,
        isEditFormAssociationsModalShown: action.isEditFormAssociationsModalShown,
        currentForm: action.currentForm,
        isTaskSuccess: false
      };
    case CLOSE_EDIT_FORM_ASSOCIATIONS_MODAL:
      return {
        ...state,
        isEditFormAssociationsModalShown: action.isEditFormAssociationsModalShown,
        editFormAssociationsResponse: action.editFormAssociationsResponse,
        editFormAssociationsError: action.editFormAssociationsError,
        isTaskSuccess: false
      };
    case CLOSE_EDIT_FORM_ASSOCIATIONS_ERROR:
      return {
        ...state,
        isEditFormAssociationsModalShown: action.isEditFormAssociationsModalShown,
        isTaskSuccess: false
      };
    case EDIT_FORM_ASSOCIATIONS_REQUEST:
      return {
        ...state,
        isRequestingEditFormAssociations: action.isRequestingEditFormAssociations
      };
    case EDIT_FORM_ASSOCIATIONS_SUCCESS:
      return {
        ...state,
        isRequestingEditFormAssociations: action.isRequestingEditFormAssociations
      };
    case EDIT_FORM_ASSOCIATIONS_ERROR:
      return {
        ...state,
        isRequestingEditFormAssociations: action.isRequestingEditFormAssociations
      };
    case OPEN_UNASSIGN_FORM_MODAL:
      return {
        ...state,
        isUnassignModalShown: action.isUnassignModalShown,
        forms: action.forms,
        isTaskSuccess: false
      };
    case CLOSE_UNASSIGN_FORM_MODAL:
      return {
        ...state,
        isUnassignModalShown: action.isUnassignModalShown,
        isTaskSuccess: false
      };
    case CLOSE_UNASSIGN_TO_USER_ERROR:
      return {
        ...state,
        isAssignToUserModalShown: action.isAssignToUserModalShown,
        isTaskSuccess: false
      };
    case UNASSIGN_TO_USER_SUCCESS:
      return {
        ...state,
        isTaskSuccess: true
      };
    case UNASSIGN_TO_USER_ERROR:
      return {
        ...state,
        isTaskSuccess: false
      };
    case PARENT_IMYFORMS_OPEN_MODAL:
      return {
        ...state,
        isParentImyFormsShown: true
      };
    case PARENT_IMYFORMS_CLOSE_MODAL:
      return {
        ...state,
        isParentImyFormsShown: false,
        parentImyForms: null
      };
    case PARENT_IMYFORMS_REQUEST:
      return {
        ...state,
        isGettingParentImyForms: true,
        parentImyForms: null
      };
    case PARENT_IMYFORMS_SUCCESS:
      return {
        ...state,
        isGettingParentImyForms: false,
        parentImyForms: action.parentImyForms
      };
    case PARENT_IMYFORMS_FAILURE:
      return {
        ...state,
        isParentImyFormsShown: false,
        isGettingParentImyForms: false,
        parentImyForms: null
      };
    case SAVE_IMY_TREEVIEW_OPTIONS:
      if (!action.id || action.id === 0) {
        return { ...state };
      }

      // eslint-disable-next-line no-case-declarations
      const elIndex = state.imyTreeViewOptions.findIndex(f => f.structureId === parseInt(action.id, 10));

      if (elIndex && elIndex !== -1) {
        state.imyTreeViewOptions[elIndex] = action.options;
      } else {
        state.imyTreeViewOptions.push(action.options);
      }

      return {
        ...state,
      };

    case CLONE_FORM_REQUEST:
      return {
        ...state,
        isCloningForm: true,
        cloneFormComplete: false
      };
    case CLONE_FORM_SUCCESS:
      return {
        ...state,
        isCloningForm: false,
        cloneFormComplete: true
      };
    case CLONE_FORM_FAILURE:
      return {
        ...state,
        isCloningForm: false,
        cloneFormComplete: false
      };
    case MOVE_FORM_REQUEST:
      return {
        ...state,
        isMovingForm: true,
        moveFormComplete: false
      };
    case MOVE_FORM_SUCCESS:
      return {
        ...state,
        isMovingForm: false,
        moveFormComplete: true
      };
    case MOVE_FORM_FAILURE:
      return {
        ...state,
        isMovingForm: false,
        moveFormComplete: false
      };
    case SET_PAYMENT_TYPES:
      if (action.structureId === 0) {
        return { ...state };
      }

      // eslint-disable-next-line no-case-declarations
      const imyTreeIndex = state.imyTreeViewOptions.findIndex(f => f.structureId === parseInt(action.structureId, 10));

      if (imyTreeIndex && imyTreeIndex !== -1) {
        return { ...state };
      }

      state.imyTreeViewOptions.push(action.options);
      return {
        ...state,
        currentStructureId: action.structureId,
      };
    case UPDATE_AVAILABLE_PAYMENT_TYPES:
      if (!action.structureId || action.structureId === 0 || !action.paymentTypes || action.paymentTypes.length === 0) {
        return { ...state };
      }

      // eslint-disable-next-line no-case-declarations
      const oIndex = state.imyTreeViewOptions.findIndex(f => f.structureId === parseInt(action.structureId, 10));

      if (oIndex && oIndex !== -1) {
        const toDelete = state.imyTreeViewOptions[oIndex].selectedPaymentTypes;
        const existing = state.imyTreeViewOptions[oIndex].availablePaymentTypes;
        action.paymentTypes = action.paymentTypes.filter(p => !toDelete.includes(p));
        state.imyTreeViewOptions[oIndex].availablePaymentTypes = [...new Set([...existing, ...action.paymentTypes])];
      }
      return { ...state };
    case SET_STRUCTURE_ID:
      return {
        ...state,
        currentStructureId: action.id
      };
    case ADD_STATEMENT_REQUEST:
      return {
        ...state,
        isAddingStatement: action.isAddingStatement
      };
    case ADD_STATEMENT_SUCCESS:
      return {
        ...state,
        isAddingStatement: action.isAddingStatement,
        addStatementResults: action.addStatementResults
      };
    case ADD_STATEMENT_FAILURE:
      return {
        ...state,
        isAddingStatement: action.isAddingStatement,
        addStatementResults: action.addStatementResults
      };
    case CREATE_WHD_REQUEST:
      return {
        ...state,
        isCreatingNewWhd: true
      };
    case CREATE_WHD_FAILURE:
      return {
        ...state,
        isCreatingNewWhd: false
      };
    case CREATE_WHD_SUCCESS:
      return {
        ...state,
        isCreatingNewWhd: false
      };
    case GET_WHD_FORMS_ACCOUNT_SUCCESS:
      return {
        ...state,
        accountWithholdingStatement: action.withholdingStatement,
        isGettingWhdForAccount: action.isGettingWhdForAccount
      };
    case GET_WHD_FORMS_ACCOUNT_REQUEST:
      return {
        ...state,
        isGettingWhdForAccount: action.isGettingWhdForAccount
      };
    case GET_WHD_FORMS_ACCOUNT_FAILURE:
      return {
        ...state,
        isGettingWhdForAccount: action.isGettingWhdForAccount
      };
    case POOLED_RATES_OPEN_MODAL:
      return {
        ...state,
        isPooledRatesModalShown: true,
        pooledRates: action.pooledRates,
        selectedPooledAccount: action.selectedPooledAccount
      };
    case POOLED_RATES_CLOSE_MODAL:
      return {
        ...state,
        isPooledRatesModalShown: false,
        pooledRates: null
      };
    case GET_WHD_VERSIONS_REQUEST:
      return {
        ...state,
        statementVersions: null,
        isLoadingStatementVersions: true
      };
    case GET_WHD_VERSIONS_SUCCESS:
      return {
        ...state,
        statementVersions: action.versions,
        isLoadingStatementVersions: false,
        refreshVersions: false
      };
    case GET_WHD_VERSIONS_FAILURE:
      return {
        ...state,
        statementVersions: null,
        isLoadingStatementVersions: false
      };
    case OPEN_SPECIAL_RATE_ADDITION_MODAL:
    case CLOSE_SPECIAL_RATE_ADDITION_MODAL:
      return {
        ...state,
        specialRatesModalError: null,
        isSpecialRatesModalShown: action.isSpecialRatesModalShown,
      };
    case OPEN_PUBLISHED_DATE_UPDATE_MODAL:
      return {
        ...state,
        isShowingPublishedVersionsUpdate: true,
        publishedVersionIndex: action.index,
        version: action.version
      };
    case CLOSE_PUBLISHED_DATE_UPDATE_MODAL:
      return {
        ...state,
        isShowingPublishedVersionsUpdate: false
      };
    case UPDATE_VERSION_STMT_SUCCESS:
      state.statementVersions.versions[action.index].effectiveFrom = action.effectiveDate;
      state.statementVersions.versions[action.index].effectiveTo = action.effectiveToDate;
      return {
        ...state,
        isSavingStatement: false,
        isPublishingStatement: false,
        refreshVersions: true
      };
    case CHECK_TIN_REQUEST:
      return {
        ...state,
        isCheckingTin: true
      };
    case CHECK_TIN_SUCCESS: {
      const newFormByIdResponse = state.formByIdResponse;
      let currentResults = state.formByIdResponse?.tinMatchResult ?? [];
      const indexOfTinMatchResult = currentResults.findIndex(result => result.formId === action.tinMatchResult[0]?.formId);

      if (indexOfTinMatchResult >= 0) {
        currentResults.splice(indexOfTinMatchResult, 1, action.tinMatchResult[0]);
      } else if (indexOfTinMatchResult === -1) {
        currentResults.push(action.tinMatchResult[0]);
      } else {
        currentResults = action.tinMatchResult;
      }

      newFormByIdResponse.tinMatchResult = currentResults;

      return {
        ...state,
        formByIdResponse: newFormByIdResponse,
        isCheckingTin: false
      };
    }
    case CHECK_TIN_FAILURE:
      return {
        ...state,
        formByIdResponse: state.formByIdResponse,
        isCheckingTin: false
      };
    case OPEN_EDIT_ADDRESS_MODAL:
      return {
        ...state,
        isEditAddressModalShown: action.isEditAddressModalShown,
        addressProps: action.addressProps
      };
    case CLOSE_EDIT_ADDRESS_MODAL:
      return {
        ...state,
        isEditAddressModalShown: action.isEditAddressModalShown,
      };
    default:
      return state;
  }
}

export default forms;
